import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { PlatformService } from 'src/app/services/platform/platform.service';

/**
 * For pages that make no sense inside the packaged mobile app (the Capacitor shell). The /local-models page, for
 * one, is the download page of the DESKTOP app: a phone can neither install nor run it, and local models are not
 * a feature of the mobile app. A link or a stale history entry that lands there is sent to the app's entry point.
 *
 * Everywhere else (web, desktop) the route is unchanged. Put it BEFORE the auth guard so the user is not first
 * sent through a login for a page they will not see.
 */
export const notInMobileAppGuard = (() => {
  const platform = inject(PlatformService);
  return platform.is('capacitor') ? inject(Router).createUrlTree(['/']) : true;
}) satisfies CanActivateFn;
